import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const EditTeamModal = ({
    selectedTeam,
    showModal,
    setShowModal,
    handleSave,
    handleBowlerChange,
    addBowler,
    setSelectedTeam
}) => {
    if (!selectedTeam) return null;

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Team</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label fw-semibold">Team Name</label>
                        <input type="text" className="form-control" value={selectedTeam.team_name} disabled />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-semibold">Place</label>
                        <input
                            type="number"
                            className="form-control"
                            value={selectedTeam.place}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => setSelectedTeam({ ...selectedTeam, place: e.target.value })}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fw-semibold">Total Wins</label>
                        <input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={selectedTeam.year_to_date_won} onChange={(e) => setSelectedTeam({ ...selectedTeam, year_to_date_won: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fw-semibold">High Game</label>
                        <input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={selectedTeam.high_game} onChange={(e) => setSelectedTeam({ ...selectedTeam, high_game: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fw-semibold">High Series</label>
                        <input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={selectedTeam.high_series} onChange={(e) => setSelectedTeam({ ...selectedTeam, high_series: e.target.value })} />
                    </div>
                </div>

                <h5 className="mt-4 mb-3 fw-bold border-bottom pb-1 text-center text-uppercase text-primary">Bowlers</h5>

                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label fw-semibold">Lane</label>
                        <input
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            className="form-control"
                            value={selectedTeam.bowler_details?.[0]?.lane || ''}
                            onChange={(e) => setSelectedTeam({
                                ...selectedTeam,
                                bowler_details: [{
                                    ...selectedTeam.bowler_details[0],
                                    lane: e.target.value
                                }]
                            })}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-semibold">HDCP</label>
                        <input
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            className="form-control"
                            value={selectedTeam.bowler_details?.[0]?.hdcp || ''}
                            onChange={(e) => setSelectedTeam({
                                ...selectedTeam,
                                bowler_details: [{
                                    ...selectedTeam.bowler_details[0],
                                    hdcp: e.target.value
                                }]
                            })}
                        />
                    </div>
                </div>

                {selectedTeam.bowler_details?.[0]?.bowler_details?.map((bowler, index) => (
                    <div key={index} className="mt-4 p-4 border rounded bg-light shadow-sm">
                        <h6 className="text-secondary fw-semibold mb-3 text-center">Bowler {index + 1}</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered align-middle text-center">
                                <thead className="table-light">
                                    <tr>
                                        <th>Name</th>
                                        <th>Avg</th>
                                        <th>HDCP</th>
                                        <th>Pins</th>
                                        <th>Gms</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="text" className="form-control" value={bowler.name} onChange={(e) => handleBowlerChange(index, "name", e.target.value)} /></td>
                                        <td><input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={bowler.avg} onChange={(e) => handleBowlerChange(index, "avg", e.target.value)} /></td>
                                        <td><input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={bowler.hdcp} onChange={(e) => handleBowlerChange(index, "hdcp", e.target.value)} /></td>
                                        <td><input type="number" className="form-control" value={bowler.pins} onChange={(e) => handleBowlerChange(index, "pins", e.target.value)} /></td>
                                        <td><input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={bowler.gms} onChange={(e) => handleBowlerChange(index, "gms", e.target.value)} /></td>
                                    </tr>
                                </tbody>
                                <thead className="table-light">
                                    <tr>
                                        <th>High Game</th>
                                        <th>High Series</th>
                                        <th>HDCP Game</th>
                                        <th>HDCP Series</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={bowler.high_game} onChange={(e) => handleBowlerChange(index, "high_game", e.target.value)} /></td>
                                        <td><input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={bowler.high_sers} onChange={(e) => handleBowlerChange(index, "high_sers", e.target.value)} /></td>
                                        <td><input type="text" className="form-control" value={bowler.hdcp_game} onChange={(e) => handleBowlerChange(index, "hdcp_game", e.target.value)} /></td>
                                        <td><input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={bowler.hdcp_sers} onChange={(e) => handleBowlerChange(index, "hdcp_sers", e.target.value)} /></td>
                                        <td><input type="number" onWheel={(e) => e.target.blur()} className="form-control" value={bowler.total} onChange={(e) => handleBowlerChange(index, "total", e.target.value)} /></td>
                                    </tr>
                                </tbody>
                                <thead className="table-light">
                                    <tr>
                                        <th>HDCP Total</th>
                                        <th>1</th>
                                        <th>2</th>
                                        <th>3</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="text" className="form-control" value={bowler.hdcp_total} onChange={(e) => handleBowlerChange(index, "hdcp_total", e.target.value)} /></td>
                                        {[0, 1, 2].map((i) => (
                                            <td key={i}>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={bowler.recent_games?.[i] ?? ''}
                                                    onChange={(e) => {
                                                        const updatedGames = [...(bowler.recent_games || [])];
                                                        updatedGames[i] = Number(e.target.value);
                                                        handleBowlerChange(index, "recent_games", updatedGames);
                                                    }}
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}

                <div className="d-flex justify-content-center mt-3">
                    <Button variant="outline-primary" onClick={addBowler}>Add Bowler</Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                <Button variant="primary" onClick={handleSave}>Save Changes</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditTeamModal;
